"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ComparisonDataDisplay = require("../ComparisonDataDisplay.styled");
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SpecsHeader = _ref => {
  let {
    shouldDisplayHeader,
    label
  } = _ref;
  return shouldDisplayHeader && /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.LightContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    text: _services.Services.locale.localeString(`SpecsGroup.${label}`),
    dataAttributes: {
      'data-test-id': 'feautres-title'
    }
  })));
};
var _default = SpecsHeader;
exports.default = _default;